export const MANAGER_ROLE_NAME = 'MANAGER';
